<template>
  <span
    v-if="name && name.length && !avatarUrl"
    class="relative flex shrink-0 items-center justify-center w-8 h-8 text-sm font-bold bg-center rounded-full bg-slate-200 dark:bg-zinc-600"
  >
    {{ initials(name) }}
  </span>
  <div v-if="avatarUrl" :style="`background-image: url('${avatarUrl}');`" class="relative shrink-0 bg-no-repeat bg-center bg-cover rounded-full w-8 h-8">
    &nbsp;
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  name: string;
  avatarUrl?: string;
}>();

const initials = (name: string) => {
  return name
    .split(' ')
    .slice(0, 2)
    .map(str => (str ? str[0].toUpperCase() : ''))
    .join('');
};
</script>
